type ListResponse<T> = { data: { success: boolean; data: T[]; message?: string } };

/** Dropdown/lookup listelerini çeker. Hata durumunda boş dizi set eder. */
export const fetchList = async <T>(
  serviceFn: () => Promise<ListResponse<T>>,
  setter: (data: T[]) => void
): Promise<void> => {
  try {
    const res = await serviceFn();
    setter(res.data.success ? res.data.data : []);
  } catch {
    setter([]);
  }
};

/** Kritik listeler için — hata fırlatır, çağıran toast gösterir. */
export const fetchListOrThrow = async <T>(
  serviceFn: () => Promise<ListResponse<T>>,
  setter: (data: T[]) => void
): Promise<void> => {
  const res = await serviceFn();
  if (!res.data.success) throw new Error(res.data.message);
  setter(res.data.data);
};
